export default __webpack_public_path__ + "static/media/sponsors.c76d5694.svg";